import React, {useContext} from 'react'
import  UserContext  from '../../context/Globales/UserContext';

import { makeStyles, useTheme } from "@material-ui/core/styles";
import {Paper }from '@material-ui/core';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";

import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";





const useStyles = makeStyles((theme) => ({

  titulo: {
  backgroundColor: theme.palette.fondotitulos.main, 
  minWidth: 200,
  color: 'dark',
  },
  table: {
    backgroundColor: theme.palette.greyFondo.main, 
  },
  alert:{
    backgroundColor: theme.palette.alerta.main
  }
}));


const DataTableInfoComercial = () => {

        const classes = useStyles();

        //const userContext = useContext(UserContext);
        const { DataOnp } = useContext(UserContext);

        function number_format(amount, decimals) {

          amount += ''; // por si pasan un numero en vez de un string
          amount = parseFloat(amount.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto
      
          decimals = decimals || 0; // por si la variable no fue fue pasada
      
          // si no es un numero o es igual a cero retorno el mismo cero
          if (isNaN(amount) || amount === 0) 
              return parseFloat(0).toFixed(decimals);
      
          // si es mayor o menor que cero retorno el valor formateado como numero
          amount = '' + amount.toFixed(decimals);
      
          var amount_parts = amount.split('.'),
              regexp = /(\d+)(\d{3})/;
      
          while (regexp.test(amount_parts[0]))
              amount_parts[0] = amount_parts[0].replace(regexp, '$1' + '.' + '$2');
      
          return amount_parts.join('.');
      }
     

    

  return ( 

        <>  
    <TableContainer component={Paper} elevation={3} >
          <div style={{textAlign: 'center', padding: '20px', fontWeight: 'bold'}} className={classes.titulo}>Tabla Informacion Comercial  </div>      
      <Table className={classes.table} stickyHeader aria-label="sticky table" size="small"  >            
        <TableHead >
              <TableRow >
              {/*data[0] && columns.map((heading) => <th> {heading}  </th> )  me trae el nombre de las columnas segun el nombre que tienen en la bd*/} 
              </TableRow>
        </TableHead>
          <TableBody>
            {/* si aqui no mapea, tengo que agregarle el ? despues del Morosidades*/}
            {DataOnp.Morosidades?.map((item)=>(
            
            <TableRow hover > 
           
            <TableCell style={{textAlign: 'justify', paddingLeft: '140px', width: '50%'}} className={ item.Valor > 0 && classes.alert} >
             {item.Concepto}              
            </TableCell> 
            <TableCell style={{textAlign: 'center'}} className={ item.Valor > 0 && classes.alert}  >
             :              
            </TableCell> 

            <TableCell style={{width: '880px', textAlign: 'left' ,  fontWeight: 'bold'}} className={ item.Valor > 0 && classes.alert} >
             {number_format(item.Valor)}             
            </TableCell> 
             </TableRow>
             ))}                  
          </TableBody>
      </Table>
    </TableContainer>
        </>
  );
}
 
export default DataTableInfoComercial;